const domain = process.env.VUE_APP_SHOPIFY_DOMAIN
const token = process.env.VUE_APP_SHOPIFY_STOREFRONT_TOKEN
const apiVersion = process.env.VUE_APP_SHOPIFY_API_VERSION || '2026-04'

const endpoint = domain ? `https://${domain}/api/${apiVersion}/graphql.json` : null

export async function shopifyFetch(query, variables = {}) {
  if (!endpoint || !token) {
    throw new Error(
      'Missing Shopify config. Copy .env.example to .env and fill in VUE_APP_SHOPIFY_DOMAIN / VUE_APP_SHOPIFY_STOREFRONT_TOKEN, then restart the dev server.'
    )
  }

  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token,
    },
    body: JSON.stringify({ query, variables }),
  })

  const json = await res.json()

  if (json.errors) {
    throw new Error(json.errors.map((e) => e.message).join('; '))
  }

  return json.data
}
